import { OrganizationFragment } from "@/__generated__/graphql";
import { DataView } from "@/components/organisms/DataView";
import { useConnectionSetup } from "@/hooks/useConnectionSetup";
import { Objects } from "@/objects";
import { State } from "@/state";

export function OrganizationsView() {
  const dataViewMode = State(
    (store) => store.dataViewModes[store.activeAppView] ?? "table",
  );

  const {
    columns,
    rows,
    loading,
    totalCount,
    deleteNodeButtonProps,
    loadNext,
    networkStatus,
  } = useConnectionSetup({ appView: "organizations" });

  return (
    <DataView
      totalCount={totalCount}
      columns={columns}
      rows={rows as OrganizationFragment[]}
      loadNext={loadNext}
      isLoading={loading}
      networkStatus={networkStatus}
      onCheckedRowsButtonsProps={[deleteNodeButtonProps]}
      viewMode={dataViewMode}
      onAddNew={() =>
        State.getState().pushToCommandStack({
          commandDefinitionId: "create-OrganizationObject",
        })
      }
      placeholderRow={Objects.OrganizationObject.placeholder}
      emptyState={{
        ReactIcon: Objects.OrganizationObject.ReactIcon,
        title: "No organizations yet",
        description:
          "The companies your contacts work for and your banks are — each with its logo, from its website's domain.",
        actionLabel: "New organization",
      }}
    />
  );
}
